export default {"src":"/_next/static/media/linkedin.d46c3e1f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};